import { useTranslation } from 'react-i18next';
import { LanguageSelector } from './LanguageSelector';
import './Header.css';

export function Header({ stats, accuracyByLeague = [], tennisStats = null }) {
  const { t } = useTranslation();

  const computedAccuracy = accuracyByLeague.length > 0
    ? accuracyByLeague.reduce((acc, lg) => acc + lg.correct, 0) /
      accuracyByLeague.reduce((acc, lg) => acc + lg.total, 0)
    : stats?.model_accuracy;

  const tennisAccuracy = tennisStats?.accuracy ?? null;
  const hasStats = stats || accuracyByLeague.length > 0 || tennisAccuracy != null;

  return (
    <div className="header">
      <div className="header-content">
        <div>
          <h1>Sport<span>Predictor</span></h1>
          <p>{t('header.subtitle')}</p>
        </div>
        <div className="header-lang-mobile"><LanguageSelector /></div>
      </div>
      {hasStats && (
        <div className="header-stats">
          {computedAccuracy != null && (
            <div className="header-stat">
              <span className="stat-value green">
                {(computedAccuracy * 100).toFixed(1)}%
              </span>
              <span className="stat-label">{t('header.accuracy')}</span>
            </div>
          )}
          {tennisAccuracy != null && (
            <div className="header-stat">
              <span className="stat-value" style={{ color: '#f59e0b' }}>
                {(tennisAccuracy * 100).toFixed(1)}%
              </span>
              <span className="stat-label">{t('header.tennis_accuracy')}</span>
            </div>
          )}
          <div className="header-stat">
            <span className="stat-value">{stats?.future_matches ?? '—'}</span>
            <span className="stat-label">{t('header.upcoming')}</span>
          </div>
          <div className="header-lang-desktop"><LanguageSelector /></div>
        </div>
      )}
      {!hasStats && (
        <div className="header-lang-only"><LanguageSelector /></div>
      )}
    </div>
  );
}